var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Price.LCLAddonFreightDetails"),
        width: "400px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view fcl-addon-form"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { no: "onSubmit", type: "primary" },
                on: { click: _vm.onSubmit }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
            ),
            _c(
              "el-button",
              { attrs: { no: "onCancel" }, on: { click: _vm.onCancel } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
            )
          ],
          1
        ),
        _c("div", { staticStyle: { width: "100%" } }, [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              {
                staticClass: "section form-column",
                staticStyle: { flex: "1" }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { ref: "pol", attrs: { label: _vm.$t("Pricing.POL") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pol",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.pol,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pol = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { ref: "pod", attrs: { label: _vm.$t("Pricing.POD") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pod",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.pod,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pod = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "currency",
                        attrs: { label: _vm.$t("Pricing.Currency") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "currency",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Currency,
                            clearable: false,
                            "default-value": _vm.price.currency
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.currency = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("Pricing.CostPrice") + "(COST)" }
                      },
                      [
                        _vm.isShow
                          ? _c("pair-numeric-stepper", {
                              attrs: {
                                one: _vm.price.costWeightPrice,
                                two: _vm.price.costVolumePrice,
                                three: _vm.price.minimumTonCost,
                                "show-three": true,
                                "one-prompt": _vm.$t("Pricing.WeightPrice"),
                                "two-prompt": _vm.$t("Pricing.VolumePrice"),
                                "three-prompt": _vm.$t("Pricing.MinimumPrice")
                              },
                              on: {
                                onChangeOne: function(p) {
                                  _vm.price.costWeightPrice = p
                                },
                                onChangeTwo: function(p) {
                                  _vm.price.costVolumePrice = p
                                },
                                onChangeThree: function(p) {
                                  _vm.price.minimumTonCost = p
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Pricing.ColoaderPrice") + "(T1)"
                        }
                      },
                      [
                        _vm.isShow
                          ? _c("pair-numeric-stepper", {
                              attrs: {
                                one: _vm.price.oneWeightPrice,
                                two: _vm.price.oneVolumePrice,
                                three: _vm.price.minimumTonPrice1,
                                "show-three": true,
                                "one-prompt": _vm.$t("Pricing.WeightPrice"),
                                "two-prompt": _vm.$t("Pricing.VolumePrice"),
                                "three-prompt": _vm.$t("Pricing.MinimumPrice")
                              },
                              on: {
                                onChangeOne: function(p) {
                                  _vm.price.oneWeightPrice = p
                                },
                                onChangeTwo: function(p) {
                                  _vm.price.oneVolumePrice = p
                                },
                                onChangeThree: function(p) {
                                  _vm.price.minimumTonPrice1 = p
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Pricing.CustomerPrice") + "(T2)"
                        }
                      },
                      [
                        _vm.isShow
                          ? _c("pair-numeric-stepper", {
                              attrs: {
                                one: _vm.price.twoWeightPrice,
                                two: _vm.price.twoVolumePrice,
                                three: _vm.price.minimumTonPrice2,
                                "show-three": true,
                                "one-prompt": _vm.$t("Pricing.WeightPrice"),
                                "two-prompt": _vm.$t("Pricing.VolumePrice"),
                                "three-prompt": _vm.$t("Pricing.MinimumPrice")
                              },
                              on: {
                                onChangeOne: function(p) {
                                  _vm.price.twoWeightPrice = p
                                },
                                onChangeTwo: function(p) {
                                  _vm.price.twoVolumePrice = p
                                },
                                onChangeThree: function(p) {
                                  _vm.price.minimumTonPrice2 = p
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("Pricing.MarketPrice") + "(T3)" }
                      },
                      [
                        _vm.isShow
                          ? _c("pair-numeric-stepper", {
                              attrs: {
                                one: _vm.price.threeWeightPrice,
                                two: _vm.price.threeVolumePrice,
                                three: _vm.price.minimumTonPrice3,
                                "show-three": true,
                                "one-prompt": _vm.$t("Pricing.WeightPrice"),
                                "two-prompt": _vm.$t("Pricing.VolumePrice"),
                                "three-prompt": _vm.$t("Pricing.MinimumPrice")
                              },
                              on: {
                                onChangeOne: function(p) {
                                  _vm.price.threeWeightPrice = p
                                },
                                onChangeTwo: function(p) {
                                  _vm.price.threeVolumePrice = p
                                },
                                onChangeThree: function(p) {
                                  _vm.price.minimumTonPrice3 = p
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Carrier") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "carrier",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { seaCmp: true },
                            "custom-label": function(item) {
                              return (
                                "[" + item.shortName + "]" + item.chineseName
                              )
                            },
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.carrier
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.carrier = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "shippingLine",
                        attrs: { label: _vm.$t("Pricing.ShippingLine") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "shippingLine", maxlength: 16 },
                          model: {
                            value: _vm.price.shippingLine,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "shippingLine", $$v)
                            },
                            expression: "price.shippingLine"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.DaysUnitSea") } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: { no: "days", min: 0, max: 999999999 },
                          model: {
                            value: _vm.price.days,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "days", $$v)
                            },
                            expression: "price.days"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "priceDateType",
                        attrs: { label: _vm.$t("Pricing.PriceDateType") }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { no: "priceDateType" },
                            model: {
                              value: _vm.price.priceDateType,
                              callback: function($$v) {
                                _vm.$set(_vm.price, "priceDateType", $$v)
                              },
                              expression: "price.priceDateType"
                            }
                          },
                          _vm._l(_vm.priceDateTypes, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "beginDate",
                        attrs: { label: _vm.$t("Pricing.BeginDate") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "beginDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.beginDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "beginDate", $$v)
                                },
                                expression: "price.beginDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "endDate",
                        attrs: { label: _vm.$t("Pricing.EndDate") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "endDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.endDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "endDate", $$v)
                                },
                                expression: "price.endDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "volumeWeightRatio",
                        attrs: { label: _vm.$t("Pricing.volumeWeightRatio") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "volumeWeightRatio",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_SystemConstants$VOLUME_WEIGHT_RATIO,
                            "custom-label": function(item) {
                              return item.name
                            },
                            "show-custom-label-in-option": true,
                            clearable: false,
                            "default-value": _vm.price.volumeWeightRatio
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.volumeWeightRatio = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.minRateValue") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.price.minRateUnit !== "最低价",
                                  expression: "price.minRateUnit !== '最低价'"
                                }
                              ],
                              staticStyle: { width: "140px" },
                              attrs: {
                                placeholder: _vm.$t("Pricing.PleaseNumber"),
                                no: "minRateValue"
                              },
                              model: {
                                value: _vm.price.minRateValue,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "minRateValue", $$v)
                                },
                                expression: "price.minRateValue"
                              }
                            }),
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "minRateUnit",
                                "select-type":
                                  _vm.selectTypeNames.local_cache_ChargeUnit,
                                clearable: false,
                                "default-value": _vm.price.minRateUnit
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.price.minRateUnit = p.code
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Remarks") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "remarks",
                            type: "textarea",
                            maxlength: 255
                          },
                          model: {
                            value: _vm.price.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "remarks", $$v)
                            },
                            expression: "price.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }